import { HttpClient } from '@angular/common/http';
import { Component, OnInit, OnDestroy, Output, EventEmitter, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalConfig, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { GridApi } from 'ag-grid-community';
import { Hotkey, HotkeysService } from 'angular2-hotkeys';
import { UtilityService } from '../shared/services/Utility.service';
import { Subscription } from 'rxjs';
import * as $ from 'jquery';
import { ButtonRendererComponent } from './masters/cellRendererCustomNotes.component';
import swal from 'sweetalert2';
@Component({
  selector: 'common-cost-centre-entry',
  template: require('./commonCostCentreEntry.html')
})
export class CommonCostCentreEntry implements OnInit, OnDestroy {
  // @Output() closePopupFn = new EventEmitter();
  @Output() messageEvent = new EventEmitter<{ isClosing: boolean, payload: {}, Doc_item_No: 0 }>();
  @Input() data: any = {};
  CostCentrePopupModalReference: any;
  CostCentrePopup: any;
  receipts: any = {};
  costCentreList: any = [];
  unitInfo: any = {};
  modalReference: NgbModalRef;
  public hotkeyListModal: Hotkey[];
  public busy: Subscription;
  static parameters = [HttpClient, HotkeysService, NgbModal,];
  frameworkComponents: { buttonRenderer: any; };
  Total_CostCentre_Adjustment: any = 0;
  toast = swal.mixin({
    toast: true,
    position: 'center',
    showConfirmButton: false,
    timer: 1000,
    backdrop: `rgba(30, 30, 37, 0.4)`
  });
  hotkeyList: any = [];
  constructor(private http: HttpClient, private hotkeysServiceCostEntery: HotkeysService, private modalService: NgbModal) {
    console.warn('created CommonCostCentreEntry component');
    console.log('input from parent', this.data);
    this.http = http;
    this.hotkeysServiceCostEntery = hotkeysServiceCostEntery;
    this.modalService = modalService;
    $(document).ready(function () {
      console.log('Jquery is ready to take action');
      // select the datafocus element and make it focus
    });
    this.receipts = {};
    this.receipts.costCentreEntry = {};
    this.receipts.costCentreEntries = [];
    this.receipts.receiptEntry = {};
    this.receipts.receiptEntry.Amount = 0;
    this.receipts.receiptEntry.amountToCostCentreAdjust = 0;
    this.Total_CostCentre_Adjustment = 0;
    this.unitInfo = JSON.parse(localStorage.getItem('permission'))[0];
    this.frameworkComponents = {
      buttonRenderer: ButtonRendererComponent,
    }

  }
  f_chknum(p_value) {
    var Num = Number(p_value);
    if (Num) {
      return Num;
    }
    return 0;
  }

  f_chkstring(p_value) {
    var Val = (p_value ? p_value.toString() : "").trim();
    return Val;
  }

  ngOnInit() {
    console.log('initiated CommonCostCentreEntry component::', this.data);
    if (this.data.costCentreEntries && this.data.costCentreEntries.length > 0) {
      this.receipts.costCentreEntries = this.data.costCentreEntries;
      // this.costCentreGridApi.setRowData(this.receipts.costCentreEntries);
      setTimeout(() => {
        this.Total_CostCentre_Adjustment = this.receipts.costCentreEntries.reduce(function (acc, sum) {
          return acc + parseFloat(sum.Amount);
        }, 0);
        console.log('this.Total_CostCentre_Adjustment', this.Total_CostCentre_Adjustment);
        this.receipts.receiptEntry.amountToCostCentreAdjust = this.f_chknum(this.receipts.receiptEntry.Amount) - this.f_chknum(this.Total_CostCentre_Adjustment);
        console.log('this.receipts.receiptEntry.amountToCostCentreAdjust', this.receipts.receiptEntry.amountToCostCentreAdjust);
        this.costCentreGridApi.setRowData(this.receipts.costCentreEntries);
      }, 800);
    }
    this.getCostCentreList();
    setTimeout(() => {
      $('#CostCentreID input[role=combobox]').focus().select();
    }, 500);

    var parent = this;
    const ctrlf = new Hotkey('ctrl+f', (event: KeyboardEvent): boolean => {
      var textbox: any;
      textbox = document.querySelector('#filter-text-box');
      if (textbox) {
        const bound = textbox.getBoundingClientRect();
        if (bound && bound.top) {
          $('#filter-text-box').focus();
        }
      }
      return false;
    }, ['INPUT', 'SELECT', 'TEXTAREA']);
    this.hotkeyList.push(ctrlf);
    this.hotkeysServiceCostEntery.add(ctrlf);
    const altckey = new Hotkey('alt+c', (event: KeyboardEvent): boolean => {
      this.altc();
      return false;
    }, ['INPUT', 'SELECT', 'TEXTAREA']);
    this.hotkeyList.push(altckey);
    this.hotkeysServiceCostEntery.add(altckey);
    const f7 = new Hotkey('f7', (event: KeyboardEvent): boolean => {
      this.updateCostEnteries();
      return false;
    }, ['INPUT', 'SELECT', 'TEXTAREA']);
    this.hotkeyList.push(f7);
    this.hotkeysServiceCostEntery.add(f7);

    $('form[name=costform] [datafocus], form[name=costform] input[role=combobox]').on('keypress', function (e) {
      if (e.which == 13) {
        e.preventDefault();
        var attr = $(this).attr('role');
        if (attr == 'combobox') {
          var res = $(this).parents(".customNgSelect").map(function () {
            return this;
          }).get();
          var index = Number($(res).attr("datafocus")) + 1;
        } else {
          var index = Number($(this).attr("datafocus")) + 1;
        }
        // if (this.classList.contains('custom-date')) {
        //   parent.customDateFormat.GetCustomDateFormat(this, parent.datepipe);
        // }
        var $next = $('[datafocus=' + index + ']');
        var tagName = $($next).prop("tagName");
        if (!$next.length) {
          if ($('form[name="costform"]').hasClass('ng-invalid')) {
            var all = $("form[name=costform] ng-select.ng-invalid, form[name=costform] input.ng-invalid, form[name=costform] select.ng-invalid, form[name=costform] textarea.ng-invalid");
            if ($(all[0]).prop("tagName") == 'NG-SELECT') {
              var focusId = $(all[0]).attr('id');
              var focusIdElem = '#' + focusId + ' input[role=combobox]';
              $(focusIdElem).focus();
            }
            else {
              $(all[0]).focus();
            }
            var errorAttr = $(all[0]).attr('data-error');
            // parent.toastWarningMsg(errorAttr);
          }
        } else if (tagName == 'NG-SELECT') {
          var elemId = $($next).attr('id');
          var focusElem = '#' + elemId + ' input[role=combobox]';
          $(focusElem).focus();
        } else {
          $next.focus();
        }
      }
    });
    $('form[name=costform]').on('keydown', 'input, select, button, textarea, input[role=combobox]', function (e) {
      var self = $(this), form = self.parents('form:eq(0)'), focusable, next;
      if (e.keyCode == 13) {
        focusable = form.find('input:enabled, a, select, button, textarea, input[role=combobox]:enabled').filter(':visible');
        next = focusable.eq(focusable.index(this) + 1);
        while (next.attr('datafocus') === "-1") {
          next = focusable.eq(focusable.index(next) + 1); // Skip the element with datafocus="-1"
        }
        if (next.length) {
          next.focus();
        } else {
          // $('#Product_ID').focus().select();
          parent.addCostCentreReceiptEntry();
        }
        return false;
      }
    });
    this.receipts.receiptEntry.Amount = this.data.Amount;
    this.Total_CostCentre_Adjustment = (this.receipts.costCentreEntries.reduce( (acc, sum) => {
      return acc + this.f_chknum(sum.Amount);
    }, 0)).toFixed(2);

    this.receipts.receiptEntry.amountToCostCentreAdjust = this.f_chknum(this.receipts.receiptEntry.Amount) - this.f_chknum(this.Total_CostCentre_Adjustment);
    console.log('this.receipts.receiptEntry.amountToCostCentreAdjust', this.receipts.receiptEntry.amountToCostCentreAdjust);

  }

  ngOnDestroy() {
    console.warn('destroyed CommonCostCentreEntry component');
    if (this.hotkeysServiceCostEntery) {
      this.hotkeysServiceCostEntery.remove(this.hotkeyList);
    }
  }


  // OpenCostCentrePopup() {

  //   this.CostCentrePopupModalReference = this.modalService.open(this.CostCentrePopup, { size: 'lg', windowClass: 'data-show width-95 vendorledger' });

  //   let self = this;
  //   this.Total_CostCentre_Adjustment = (this.receipts.costCentreEntries.reduce(function (acc, sum) {
  //     return acc + self.f_chknum(sum.Amount);
  //   }, 0)).toFixed(2);

  //   this.receipts.receiptEntry.amountToCostCentreAdjust = this.receipts.receiptEntry.Amount - this.Total_CostCentre_Adjustment;
  //   this.CostCentrePopupModalReference.result.then((result) => {
  //     var self = this;
  //     console.log(result);
  //     console.log('closed');

  //     if (this.f_chknum(this.receipts.receiptEntry.amountToCostCentreAdjust) != this.f_chknum(this.receipts.receiptEntry.Amount) && this.f_chknum(this.receipts.receiptEntry.amountToCostCentreAdjust) != 0) {
  //       //this.toastWarningMsg('1');
  //       return false;
  //     }
  //     this.CostCentrePopupModalReference = null;
  //   }, (reason) => {
  //     console.log(reason);
  //     console.log('dismissed');
  //     if (this.f_chknum(this.receipts.receiptEntry.amountToCostCentreAdjust) != this.f_chknum(this.receipts.receiptEntry.Amount) && this.f_chknum(this.receipts.receiptEntry.amountToCostCentreAdjust) != 0) {
  //       //this.toastWarningMsg('2');
  //       this.CostCentrePopupModalReference = null;
  //       return false;
  //     }
  //   });
  // }



  getCostCentreList(): void {
    this.http.post('/api/costcenter/getCostCentreList', { 'CreatedBy': this.unitInfo._id })
      .subscribe(response => {
        this.costCentreList = response;
      });
  }

  keydownfn(event) {
    console.log(event);
    if (event.which == 13) {
      this.costCentreGridApi.setFocusedCell(0, "Series");
      this.costCentreGridApi.getModel().getRow(0).setSelected(true);
    }
  }
  onFilterTextBoxChanged2() {
    let value = $('input#filter-text-box').val();
    this.costCentreGridApi.setQuickFilter(value);
  }
  costCentreGridApi: GridApi;
  costCentreGridColumnApi: any;
  costCentreColumnDefs: any = [
    // { headerName: 'Cost Centre ID', field: 'CostCentre_ID', width: 150 },
    { headerName: 'Cost Centre', field: 'CostCentre_Name', width: 300 },
    { headerName: 'Amount', field: 'Amount', width: 150 },
    {
      headerName: 'Action', field: 'Action', width: 150,
      cellRenderer: 'buttonRenderer',
      cellRendererParams: {
        onClick: this.onRowClickedRemove.bind(this),
        icon: 'fa fa-trash',
      },
    }
  ];
  onGridReadyCostCentre(params) {
    this.costCentreGridApi = params.api;
    this.costCentreGridColumnApi = params.columnApi;
  }
  onSelectionChanged2() {

  }

  onCostCentreChange(event) {
    this.receipts.costCentreEntry.CostCentre = this.costCentreList.filter(x => x.CostCentreID == event)[0].CostCentre || '';
  }


  addCostCentreReceiptEntry() {
    if (this.receipts.costCentreEntry.CostCentreID == '' || this.receipts.costCentreEntry.CostCentreID == null || this.receipts.costCentreEntry.CostCentreID == undefined) {
      this.toastWarningMsg("Please enter Cost Centre");
      setTimeout(() => {
        $('#CostCentreID input[role=combobox]').focus().select();
      }, 200);
      return false;
    }
    if (this.receipts.costCentreEntry.Amount == '' || this.receipts.costCentreEntry.Amount == null || this.receipts.costCentreEntry.Amount == undefined) {
      this.toastWarningMsg("Please enter valid Amount");
      $('#costAmount').focus().select();
      return false;
    }
    if (this.receipts.costCentreEntry.Amount <= 0) {
      this.toastWarningMsg("Amount should be greater than 0");
      $('#costAmount').focus().select();
      return false;
    }
    // check if selected cost centre is already added
    // let isExist = this.receipts.costCentreEntries.filter(x => x.CostCentre_ID == this.receipts.costCentreEntry.CostCentreID && x.Amount == this.receipts.costCentreEntry.Amount);
    if(this.isEditCostCentreEntry ==false){
      let isExist = this.receipts.costCentreEntries.filter(x => x.CostCentre_ID == this.receipts.costCentreEntry.CostCentreID);
      if (isExist.length > 0) {
        this.toastWarningMsg("Cost Centre already added");
        $('#CostCentreID input[role=combobox]').focus().select();
        return false;
      }
    }

    let data = {
      "CostCentre_ID": this.receipts.costCentreEntry.CostCentreID,
      "CostCentre_Name": this.receipts.costCentreEntry.CostCentre,
      "Amount": this.receipts.costCentreEntry.Amount,
    };

    if (this.isEditCostCentreEntry) {

      let index = this.receipts.costCentreEntries.findIndex(x => x.CostCentre_ID == this.receipts.costCentreEntry.CostCentreID);
      // 600> (500 - 600) + 400
      // if (data.Amount > ((this.receipts.costCentreEntries[index].Amount - data.Amount) + this.receipts.receiptEntry.amountToCostCentreAdjust)) {
      //   this.toastWarningMsg("Amount should not be greater than pending amount to adjust edit");
      //   console.log('data.amount',data.Amount);
      //   console.log('this.receipts.costCentreEntries[index].Amount',this.receipts.costCentreEntries[index].Amount);
      //   console.log('this.receipts.receiptEntry.amountToCostCentreAdjust',this.receipts.receiptEntry.amountToCostCentreAdjust);
      //   return false;
      // }

      let dd = this.f_chknum(this.Total_CostCentre_Adjustment) - this.f_chknum(this.receipts.costCentreEntries[index].Amount);
      let dd2 = this.f_chknum(dd) + this.f_chknum(data.Amount);

      if (dd2 > this.f_chknum(this.receipts.receiptEntry.Amount)) {
        this.toastWarningMsg("Amount should not be greater than pending amount to adjust.");
        return false;
      }
      this.receipts.costCentreEntries[index].Amount = data.Amount;

    } else {
      if (this.receipts.receiptEntry.amountToCostCentreAdjust < data.Amount) {
        this.toastWarningMsg("Amount should not be greater than pending amount to adjust.");
        return false;
      }
      this.receipts.costCentreEntries.push(data);
    }

    let self = this;
    setTimeout(() => {
      this.Total_CostCentre_Adjustment = (this.receipts.costCentreEntries.reduce(function (acc, sum) {
        return acc + self.f_chknum(sum.Amount);
      }, 0)).toFixed(2);
      this.receipts.receiptEntry.amountToCostCentreAdjust = this.f_chknum(this.receipts.receiptEntry.Amount) - this.f_chknum(this.Total_CostCentre_Adjustment);
      this.costCentreGridApi.setRowData(this.receipts.costCentreEntries);
    }, 500);

    this.receipts.costCentreEntry.CostCentreID = '';
    this.receipts.costCentreEntry.CostCentre = '';
    this.receipts.costCentreEntry.Amount = '';
    this.isEditCostCentreEntry = false;
    $('#CostCentreID input[role=combobox]').focus().select();
  }

  isEditCostCentreEntry: boolean = false;
  onRowClicked(event) {
    $('#costAmount').focus().select();
    this.receipts.costCentreEntry.CostCentreID = event.data.CostCentre_ID;
    this.receipts.costCentreEntry.Amount = event.data.Amount;
    this.isEditCostCentreEntry = true;
  }
  altc() {
    this.receipts.costCentreEntry.CostCentreID = '';
    this.receipts.costCentreEntry.Amount = '';
    this.isEditCostCentreEntry = false;
    $('#CostCentreID input[role=combobox]').focus().select();
  }
  onRowClickedRemove(id) {
    console.log(id);
    var self = this;

    // set amount to zero
    let index = this.receipts.costCentreEntries.findIndex(x => x.CostCentre_ID == id.rowData.CostCentre_ID);
    this.receipts.costCentreEntries[index].Amount = 0;
    setTimeout(() => {
      this.Total_CostCentre_Adjustment = (this.receipts.costCentreEntries.reduce(function (acc, sum) {
        return acc + self.f_chknum(sum.Amount);
      }, 0)).toFixed(2);
      this.receipts.receiptEntry.amountToCostCentreAdjust = this.receipts.receiptEntry.Amount - this.Total_CostCentre_Adjustment;
      this.costCentreGridApi.setRowData(this.receipts.costCentreEntries);
    }, 500);
  }
  closeMe() {
    console.log('closeMe');
    // this.closePopupFn.emit('');
    this.messageEvent.emit({
      isClosing: true, // Fix: Change the value to false
      payload: this.receipts,
      Doc_item_No: this.data.Doc_item_No == undefined ? 0 : this.data.Doc_item_No
    });
  }
  toastWarningMsg(msg) {
    this.toast({
      type: 'warning',
      title: msg,
      timer: 2500
    });
  }
  updateCostEnteries() {
    console.log('updateCostEnteries and close');
    console.log("this.Total_CostCentre_Adjustment::", this.Total_CostCentre_Adjustment);
    console.log("this.Total_CostCentre_Adjustment::", this.Total_CostCentre_Adjustment);
    if (this.receipts.costCentreEntries.length > 0) {
      if (this.f_chknum(this.Total_CostCentre_Adjustment) !== this.f_chknum(this.data.Amount)) {
        this.toastWarningMsg("Amount should be equal to pending amount to adjust.");
        return false;
      }
    }
    this.messageEvent.emit({
      isClosing: true,
      payload: this.receipts,
      Doc_item_No: this.data.Doc_item_No == undefined ? 0 : this.data.Doc_item_No
    });
  }
}
